import React, { Suspense, lazy } from "react";
import { createHashRouter, RouterProvider } from "react-router-dom";
import "./App.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import SignUp from "./Components/SignUp/SignUp";
import AuthProvider from "./AuthProvider";
import { GoogleOAuthProvider } from "@react-oauth/google";
import Trainers from "./Components/Dashboard/Trainers/Trainers";
import Users from "./Components/Dashboard/Users/Users";
import { ToastContainer } from "react-toastify";
import { ThemeProvider } from "@material-tailwind/react";
import LinkedInLogin from "./Components/LinkedInLogin/LinkedInLogin";
import AddPasswordPage from "./Components/AddPasswordPage/AddPasswordPage";
import Payment from "./Components/Payment/Payment";
import Addcourse from "./Components/Addcourse/Add";
import Moodle from "./Components/Moodle/Moodle";
import CreateCourseModal from "./Pages/CreateCourseModal/CreateCourseModal";

import ResetPassword from "./Components/Resetpassword/Resetpassword";
import ForgotPassword from "./Components/ForgotPassword/ForgotPassword";
import Policy from "./Pages/Policy/Policy";
// import Dashboard from "./Components/Dashboard/Dashboard";
 

// Lazy-loaded components
const Layout = lazy(() => import("./Components/Layout/Layout"));
const Home = lazy(() => import("./Components/Home/Home"));
const Coursedetails = lazy(() => import("./Components/Coursedetails/Coursedetails"));
const Usercourses = lazy(() => import("./Components/Usercourses/Courses"));
const Courses = lazy(() => import("./Components/Courses/Courses"));
const Login = lazy(() => import("./Components/Login/Login"));
const Trainerprofile = lazy(() => import("./Components/Trainerprofile/Trainerprofile"));
const Landingpage = lazy(() => import("./Components/Landingpage/Page"));
const Maincourses = lazy(() => import("./Components/Dashboard/Maincourses/Courses-dashboard"));
const Courseoverview = lazy(() => import("./Components/Courseoverview/Course"));


// Dashboard lazy-loaded layout and pages
const Dashboard = lazy(() => import("./Components/Dashboard/Dashboard"));
const DashboardLayout = lazy(() => import("./Components/Layout/DashboardLayout"));

const queryClient = new QueryClient();

const loadingScreen = (
  <div className="flex justify-center items-center h-screen my-12">
    <span className="loader my-8"></span>
  </div>
);

const routes = createHashRouter([
  {
    path: "/",
    element: (
      <Suspense fallback={loadingScreen}>
        <Layout />
      </Suspense>
    ),
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={loadingScreen}>
            <Home />
          </Suspense>
        ),
      },
      {
        path: "home",
        element: (
          <Suspense fallback={loadingScreen}>
            <Home />
          </Suspense>
        ),
      },
      {
        path: "course-details/:id",
        element: (
          <Suspense fallback={loadingScreen}>
            <Coursedetails />
          </Suspense>
        ),
      },
      {
        path: "trainer-profile/:id",
        element: (
          <Suspense fallback={loadingScreen}>
            <Trainerprofile />
          </Suspense>
        ),
      },
      {
        path: "course-overview",
        element: (
          <Suspense fallback={loadingScreen}>
            <Courseoverview />
          </Suspense>
        ),
      },
            {
        path: "policy",
        element: (
          <Suspense fallback={loadingScreen}>
            <Policy />
          </Suspense>
        ),
      },
                  {
        path: "moodle",
        element: (
          <Suspense fallback={loadingScreen}>
            <Moodle />
          </Suspense>
        ),
      },
      {
        path: "landing-page",
        element: (
          <Suspense fallback={<div className="flex justify-center items-center h-screen my-12"><span className="loader my-8"></span></div>}>
            <Landingpage />
          </Suspense>
        ),
      },

      {
        path: "payment",
        element: (
          <Suspense fallback={<div className="flex justify-center items-center h-screen my-12"><span className="loader my-8"></span></div>}>
            <Payment />
          </Suspense>
        ),
      },
      {
        path: "add-password",
        element: (
          <Suspense fallback={loadingScreen}>
            <AddPasswordPage />
          </Suspense>
        ),

      },

      {
        path: "courses",
        element: (
          <Suspense fallback={loadingScreen}>
            <Courses />
          </Suspense>
        ),
      },
      {
        path: "login",
        element: (
          <Suspense fallback={loadingScreen}>
            <Login />
          </Suspense>
        ),
      },
      {
        path: "signup",
        element: (
          <Suspense fallback={loadingScreen}>
            <SignUp />
          </Suspense>
        ),
      },
      {
        path: "forgot-password",
        element: (
          <Suspense fallback={loadingScreen}>
            <ForgotPassword />
          </Suspense>
        ),
      },
      {
        path: "reset-password",
        element: (
          <Suspense fallback={loadingScreen}>
            <ResetPassword />
          </Suspense>
        ),
      },
      // {
      //   path: "linkedin",
      //   element: (
      //     <Suspense fallback={loadingScreen}>
      //       <LinkedInLogin />
      //     </Suspense>
      //   ),
      // },
      {
        path: "usercourses",
        element: (
          <Suspense fallback={loadingScreen}>
            <Usercourses />
          </Suspense>
        ),
      },
    ],
  },



  {
    path: "/dashboard",
    element: (
      <Suspense fallback={loadingScreen}>
        <DashboardLayout />
      </Suspense>
    ),
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={loadingScreen}>
            <Dashboard />
          </Suspense>
        ),
      },
      {
        path: "trainers",
        element: (
          <Suspense fallback={loadingScreen}>
            <Trainers />
          </Suspense>
        ),
      },
      {
        path: "users",
        element: (
          <Suspense fallback={loadingScreen}>
            <Users />
          </Suspense>
        ),
      },
      {
        path: "courses",
        element: (
          <Suspense fallback={loadingScreen}>
            <Maincourses />
          </Suspense>
        ),
      },
      {
        path: "add-course",
        element: (
          <Suspense fallback={loadingScreen}>
            <Addcourse />
          </Suspense>
        ),

      },
    ],
  },
]);

const CLIENT_ID = "591546659165-0qussjktgnt388l5rc5l6e89nd97dh0k.apps.googleusercontent.com";

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ThemeProvider>
          <GoogleOAuthProvider clientId={CLIENT_ID}>
            <RouterProvider router={routes} />
            <ToastContainer position="top-right"
              autoClose={3000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover />
          </GoogleOAuthProvider>

        </ThemeProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
